<!-- 子组件 -->
<template>
	<div>
		<!-- 选择用户 -->
		<el-dialog title="选择用户" top="2rem" :visible.sync="selectUserBox" width="80%" center :append-to-body="true">
			<span>
				<div class='components_content_box'>
					<div class="components_content_top">
						<el-form :inline="true" :model="getUserRequestData" class="demo-form-inline">
							<el-form-item label="名称">
								<el-input v-model.trim="getUserRequestData.opmName"  size="mini" placeholder="名称" ></el-input>
							</el-form-item>
							<el-form-item label="分组">
								<el-select v-model="getUserRequestData.opgId"  size="mini"  placeholder="选择分组">
									<el-option  label="全部" value="">
									</el-option>
									<el-option  v-for="(groupValue,groupKey) in userGroupList" :key="groupKey" :label="groupValue.opgName" :value="groupValue.opgId">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getDataList()">刷新</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="components_content_content">
						<el-table stripe :data="returnUserData.list"  @row-dblclick="setUserValueAction" height="100%" border  style="width: 100%" highlight-current-row>
							<el-table-column type="expand" label="人员身份" width="80">
								<template slot-scope="props">
									<el-tabs type="border-card">
										<el-tab-pane label="人员身份">
											<el-table :data="[props.row]"  border  style="width: 100%">
												<el-table-column prop="opmAcceptor"  label="是否验收人"  >
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmAcceptor == 0" title="不是验收人" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmAcceptor == 1" title="是验收人" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmBuyer"  label="是否采购员">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmBuyer == 0" title="不是采购员" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmBuyer == 1" title="是采购员" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmCashier"  label="是否收款员" >
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmCashier == 0" title="不是收款员" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmCashier == 1" title="是收款员" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmDistributor"  label="是否配送员">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmDistributor == 0" title="不是配送员" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmDistributor == 1" title="是配送员" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmDoctor"  label="是否医师">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmDoctor == 0" title="不是医师" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmDoctor == 1" title="是医师" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmDriver"  label="是否司机">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmDriver == 0" title="不是司机" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmDriver == 1" title="是司机" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmHeader"  label="是否部门主管">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmHeader == 0" title="不是部门主管" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmHeader == 1" title="是部门主管" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmKeeper"  label="是否保管员">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmKeeper == 0" title="不是保管员" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmKeeper == 1" title="是保管员" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmPharmacist"  label="是否执业药师">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmPharmacist == 0" title="不是执业药师" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmPharmacist == 1" title="是执业药师" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmReviewer"  label="是否复核人">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmReviewer == 0" title="不是复核人" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmReviewer == 1" title="是复核人" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
												<el-table-column prop="opmSalesperson"  label="是否销售员">
													<template slot-scope="subprops">
														<el-alert v-if="subprops.row.opmSalesperson == 0" title="不是销售员" type="error" effect="dark"  :closable="false">
														</el-alert>
														<el-alert v-if="subprops.row.opmSalesperson == 1" title="是销售员" type="success" effect="dark"  :closable="false">
														</el-alert>
													</template>
												</el-table-column>
											</el-table>
										</el-tab-pane>
									</el-tabs>
								</template>
							</el-table-column>
							<el-table-column  prop="opmCode"  label="编码">
							</el-table-column>
							<el-table-column prop="depName" label="归属部门" >
							</el-table-column>
							<el-table-column prop="opgName" label="所属分组" >
							</el-table-column>
							<el-table-column prop="opmName" label="姓名"  >
							</el-table-column>
							<el-table-column prop="opmAccount" label="登录账号" >
							</el-table-column>
							<el-table-column prop="opmMobilenumber" label="手机号" >
							</el-table-column>
							<el-table-column prop="opmTelenumber" label="固话" >
							</el-table-column>
							<el-table-column prop="opmIdnumber" label="身份证号" >
							</el-table-column>
							<el-table-column prop="opmSex" label="性别" ></el-table-column>
							<el-table-column prop="opmState" label="状态" >
								<template slot-scope="scope">
									{{$store.state.userStatus[scope.row.opmState].name}}
								</template>
							</el-table-column>
							<el-table-column prop="opmEmail" label="邮箱" >
							</el-table-column>
							<el-table-column prop="opmOnlinetime" label="在线时间" >
								<template slot-scope="scope">
									<div v-if="scope.row.opmOnlinetime">
										{{$common.getLocalTime(scope.row.opmOnlinetime)}}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="components_content_bottom">
						<el-pagination
							background
							@size-change="setDataPageSize"
							@current-change="setDataPageNumber"
							:current-page="getUserRequestData.page"
							:page-sizes="[30,50,100,500]"
							:page-size="30"
							layout="total, sizes, prev, pager, next, jumper"
							:total="returnUserData.total">
						</el-pagination>
					</div>
				</div>
			</span>
		</el-dialog>
		
		<!-- 选择业务商品 -->
		<el-dialog title="选择业务商品" top="2rem" :visible.sync="selectBusinessGoodsBox" width="80%" center :append-to-body="true">
			<span>
				<div class='components_content_box'>
					<div class="components_content_top">
						<el-form :inline="true" :model="getBusinessGoodsRequestData" class="demo-form-inline">
							<el-form-item label="名称">
								<el-input v-model.trim="getBusinessGoodsRequestData.bgmName"  size="mini" placeholder="名称" ></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchBusinessGoodsData">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getBusinessGoods()">刷新</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="components_content_content">
						<el-table stripe :data="returnBusinessGoodsData.list" @row-dblclick="setBisomessGppdsValueAction" height="100%" border  style="width: 100%" highlight-current-row>
							<el-table-column  prop="bgmName"  label="通用名称">
							</el-table-column>
							<el-table-column  prop="bgmBarcode"  label="条码">
							</el-table-column>
							<el-table-column  prop="bgmManufacturer"  label="生产商">
							</el-table-column>
							<el-table-column  prop="bgmSpecifications"  label="规格">
							</el-table-column>
							<el-table-column  prop="bgmPlaceorigin"  label="产地">
							</el-table-column>
							<el-table-column  prop="busgoodfinance.bgfIntaxrate"  label="进项税率">
							</el-table-column>
							<el-table-column  prop="busgoodfinance.bgfOuttaxrate"  label="销项税率">
							</el-table-column>
							<el-table-column  prop="bgmRemarks"  label="备注">
							</el-table-column>
						</el-table>
					</div>
					<div class="components_content_bottom">
						<el-pagination
							background
							@size-change="setBusinessGoodsPageSize"
							@current-change="setBusinessGoodsPageNumber"
							:current-page="getBusinessGoodsRequestData.page"
							:page-sizes="[30,50,100,500]"
							:page-size="30"
							layout="total, sizes, prev, pager, next, jumper"
							:total="returnBusinessGoodsData.total">
						</el-pagination>
					</div>
				</div>
			</span>
		
		</el-dialog>
		
		<!-- 供货商 -->
		<el-dialog title="选择供货商" top="2rem" :visible.sync="selectSupplierBox" width="80%" center :append-to-body="true">
			<span>
				<div class='components_content_box'>
					<div class="components_content_top">
						<el-form :inline="true" :model="getSupplierRequestData" class="demo-form-inline">
							<el-form-item label="名称">
								<el-input v-model.trim="getSupplierRequestData.smName"  size="mini" placeholder="名称" ></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchSupplierData">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getSupplier()">刷新</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="components_content_content">
						<el-table stripe :data="returnSupplierData.list" @row-dblclick="setSupplierValueAction" height="100%" border  style="width: 100%" highlight-current-row>
							<el-table-column  prop="smName"  label="名称">
							</el-table-column>
							<el-table-column  prop="smIntype"  label="单位类型">
							</el-table-column>
							<el-table-column  prop="smManrange"  label="生产范围">
							</el-table-column>
							<el-table-column  prop="smProrange"  label="经营范围">
							</el-table-column>
							<el-table-column  prop="smLegalperson"  label="法定代表人">
							</el-table-column>
							<el-table-column  prop="smSocialcode"  label="统一社会信用代码">
							</el-table-column>
						</el-table>
					</div>
					<div class="components_content_bottom">
						<el-pagination
							background
							@size-change="setSupplierPageSize"
							@current-change="setSupplierPageNumber"
							:current-page="getSupplierRequestData.page"
							:page-sizes="[30,50,100,500]"
							:page-size="30"
							layout="total, sizes, prev, pager, next, jumper"
							:total="returnSupplierData.total">
						</el-pagination>
					</div>
				</div>
			</span>
		</el-dialog>
		
		<!-- 货主 -->
		<el-dialog title="选择货主" top="2rem" :visible.sync="selectCargoOwnerBox" width="80%" center :append-to-body="true">
			<span>
				<div class='components_content_box'>
					<div class="components_content_top">
						<el-form :inline="true" :model="getSupplierRequestData" class="demo-form-inline">
							<el-form-item label="名称">
								<el-input v-model.trim="getSupplierRequestData.coName"  size="mini" placeholder="名称" ></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchCargoOwnerData">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getCarOwnerList()">刷新</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="components_content_content">
						<el-table stripe :data="returnCargoOwnerData.list"  @row-dblclick="setCargoOwnerValueAction" height="100%" border  style="width: 100%" highlight-current-row>
							<el-table-column prop="coName" label="名称">
							</el-table-column>
							<el-table-column prop="ormName" label="归属组织" >
							</el-table-column>
							<el-table-column prop="coState" label="状态" >
								<template slot-scope="scope">
									<el-alert v-if="scope.row.coState == 0"  title="停用" type="error"  effect="dark"  :closable="false">
									</el-alert>
									<el-alert v-else-if="scope.row.coState == 1"  title="启用" type="success"  effect="dark"  :closable="false">
									</el-alert>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="components_content_bottom">
						<el-pagination
							background
							@size-change="setCargoOwnerPageSize"
							@current-change="setCargoOwnerPageNumber"
							:current-page="getCargoOwnerRequestData.page"
							:page-sizes="[30,50,100,500]"
							:page-size="30"
							layout="total, sizes, prev, pager, next, jumper"
							:total="returnCargoOwnerData.total">
						</el-pagination>
					</div>
				</div>
			</span>
		</el-dialog>
		
		<!-- 选择客户 -->
		<el-dialog title="选择客户" top="2rem" :visible.sync="selectCustomerBox" width="80%" center :append-to-body="true">
			<span>
				<div class='components_content_box'>
					<div class="components_content_top">
						<el-form :inline="true" :model="getCustomerRequestData" class="demo-form-inline">
							<el-form-item label="名称">
								<el-input v-model.trim="getCustomerRequestData.cmName"  size="mini" placeholder="名称" ></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getCustomerList()">刷新</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="components_content_content">
						<el-table stripe :data="returnCustomerData.list" @row-dblclick="setCustomerValueAction"  height="100%" border  style="width: 100%" highlight-current-row>
							<el-table-column type="expand" label="其它" width="70">
								<template slot-scope="props">
									<el-tabs type="border-card">
										<el-tab-pane label="客户地址信息">
											<el-table :data="props.row.cusaddresses"  border  style="width: 100%">
												<el-table-column prop="caiCountry"  label="国家"  >
												</el-table-column>
												<el-table-column prop="caiProvince"  label="省"  >
												</el-table-column>
												<el-table-column prop="caiCity"  label="市"  >
												</el-table-column>
												<el-table-column prop="caiArea"  label="区"  >
												</el-table-column>
												<el-table-column prop="caiAddress"  label="地址"  >
												</el-table-column>
												<el-table-column prop="caiLinker"  label="联系人"  >
												</el-table-column>
												<el-table-column prop="caiTelnumber"  label="电话"  >
												</el-table-column>
												<el-table-column prop="caiPostcode"  label="邮编"  >
												</el-table-column>
											</el-table>
										</el-tab-pane>
										<el-tab-pane label="客户银行信息">
											<el-table :data="props.row.cusbankinfos"  border  style="width: 100%">
												<el-table-column prop="cbiName"  label="银行"  >
												</el-table-column>
												<el-table-column prop="cbiNumber"  label="账号"  >
												</el-table-column>
												<el-table-column prop="cbiAddress"  label="地址"  >
												</el-table-column>
												<el-table-column prop="cbiTelnumber"  label="电话"  >
												</el-table-column>
											</el-table>
										</el-tab-pane>
										<el-tab-pane label="客户财务信息">
											<el-table :data="props.row.cusfinancelinfos"  border  style="width: 100%">
												<el-table-column prop="cfiAcollect"  label="预收款"  >
												</el-table-column>
												<el-table-column prop="cfiApayment"  label="预付款"  >
												</el-table-column>
												<el-table-column prop="cfiCreditamount"  label="信贷额"  >
												</el-table-column>
												<el-table-column prop="cfiCreditperiod"  label="信贷期"  >
												</el-table-column>
												<el-table-column prop="cfiScollect"  label="应收款"  >
												</el-table-column>
												<el-table-column prop="cfiSpayment"  label="应付款"  >
												</el-table-column>
											</el-table>
										</el-tab-pane>
									</el-tabs>
								</template>
							</el-table-column>
							
							<el-table-column  prop="cmCode"  label="编码">
							</el-table-column>
							<el-table-column prop="cmName" label="名称" >
							</el-table-column>
							<el-table-column prop="cmLegalperson" label="法定代表人" >
							</el-table-column>
							<el-table-column prop="cmIntype" label="单位类型"  >
							</el-table-column>
							<el-table-column prop="cmSocialcode" label="统一社会信用代码" >
							</el-table-column>
							<el-table-column prop="cmProrange" label="经营范围" >
							</el-table-column>
							<el-table-column prop="cmRegaddres" label="注册地址" >
							</el-table-column>
							<el-table-column prop="cmRegmoney" label="注册资本" >
							</el-table-column>
							
						</el-table>
					</div>
					<div class="components_content_bottom">
						<el-pagination
							background
							@size-change="setDataPageSize"
							@current-change="setDataPageNumber"
							:current-page="getCustomerRequestData.page"
							:page-sizes="[30,50,100,500]"
							:page-size="30"
							layout="total, sizes, prev, pager, next, jumper"
							:total="returnUserData.total">
						</el-pagination>
					</div>
				</div>
			</span>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'subComponentsBak',
	props:['pageAttributeName'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            selectUserBox: false,
			getUserRequestData:{
				opmName:'',
				depState:'',
				opgId:'',
				depId:'',
				page:1,
				rows:30,
			},
			returnUserData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			userGroupList:[],
			groupSearch:{
				opgName:'',
			},
			
			fieldName:'',
			fieldValue:'',
			
			selectBusinessGoodsBox: false,
			getBusinessGoodsRequestData:{
				bgmName:'',
				bgmActivestatus:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			
			returnBusinessGoodsData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			
			selectSupplierBox: false,
			getSupplierRequestData:{
				smName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			
			returnSupplierData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			// 货主
			selectCargoOwnerBox: false,
			getCargoOwnerRequestData:{
				coName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			
			returnCargoOwnerData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			// 客户
			selectCustomerBox: false,
			getCustomerRequestData:{
				cmName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			
			returnCustomerData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		
		/**
		 * @param {Object} componentsName  要打开组件的名称
		 * @param {Object} objname         要修改父组件的对象
		 * @param {Object} objvalue		   要获取子组件的值
		 */
		openBox(componentsName,objname,objvalue){
			
			this.fieldName = objname
			this.fieldValue = objvalue
			switch(componentsName){
				
				case 'opmList':  // 人员
					this.openSelectUserBox()
					break;
				case 'businessGoodsList':  // 业务商品
					this.getBusinessGoods()
					break;
				case 'supplierList': // 供货商
					this.getSupplier()
					break;
				case 'cargoOwnerList': // 货主
					this.getCarOwnerList()
					break;
				case 'customerList': // 客户
					this.getCustomerList()
					break;
			}
			
		},
		setCustomerValueAction(row){
			this.selectCustomerBox =  false,
			sessionStorage.setItem('selectCustomerData',JSON.stringify(row))
			this.$parent.isShowData(this.fieldName,row[this.fieldValue])
		},
		
		// 数据搜索
		searchCustomerData() {
			this.getCustomerRequestData.page = 1
			this.getCustomerList()
		},
		// 数据翻页
		setCustomerPageNumber(val){
			this.getCustomerRequestData.page = val
			this.getCustomerList()
		},
		
		// 切换显示条数
		setCustomerPageSize(val){
			this.getCustomerRequestData.page = 1
			this.getCustomerrRequestData.rows = val
			this.getCustomerList()
		},
		
		// 获取客户
		async getCustomerList(){
			let responseData =  await this.$http.getCusmaster(this.getCustomerRequestData)
			if(responseData.status == 200){
				this.returnCustomerData.list = responseData.result.list
				this.returnCustomerData.pages = responseData.result.pages
				this.returnCustomerData.total = responseData.result.total
				this.returnCustomerData.pageNum = responseData.result.pageNum
				
				this.selectCustomerBox = true
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		setCargoOwnerValueAction(row,column,event){
			this.selectCargoOwnerBox =  false,
			sessionStorage.setItem('selectCargoOwnerData',JSON.stringify(row))
			this.$parent.isShowData(this.fieldName,row[this.fieldValue])
		},
		// 数据搜索
		searchCargoOwnerData() {
			this.getCargoOwnerRequestData.page = 1
			this.getCarOwnerList()
		},
		// 数据翻页
		setCargoOwnerPageNumber(val){
			this.getCargoOwnerRequestData.page = val
			this.getCarOwnerList()
		},
		
		// 切换显示条数
		setCargoOwnerPageSize(val){
			this.getCargoOwnerRequestData.page = 1
			this.getCargoOwnerRequestData.rows = val
			this.getCarOwnerList()
		},
		// 获取货主
		async getCarOwnerList(){
			let responseData =  await this.$http.getCarOwnerList(this.getCargoOwnerRequestData)
			if(responseData.status == 200){
				this.returnCargoOwnerData.list = responseData.result.list
				this.returnCargoOwnerData.pages = responseData.result.pages
				this.returnCargoOwnerData.total = responseData.result.total
				this.returnCargoOwnerData.pageNum = responseData.result.pageNum
				
				this.selectCargoOwnerBox = true
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		setSupplierValueAction(row,column,event){
			
			this.selectSupplierBox =  false
			sessionStorage.setItem('selectSupplierData',JSON.stringify(row))
			this.$parent.isShowData(this.fieldName,row[this.fieldValue])
			
		},
		// 数据搜索
		searchSupplierData() {
			this.getSupplierRequestData.page = 1
			this.getSupplier()
		},
		// 数据翻页
		setSupplierPageNumber(val){
			this.getSupplierRequestData.page = val
			this.getSupplier()
		},
		
		// 切换显示条数
		setSupplierPageSize(val){
			this.getSupplierRequestData.page = 1
			this.getSupplierRequestData.rows = val
			this.getSupplier()
		},
		// 获取供货商
		async getSupplier(){
			let responseData =  await this.$http.getSupplier(this.getSupplierRequestData)
			if(responseData.status == 200){
				this.returnSupplierData.list = responseData.result.list
				this.returnSupplierData.pages = responseData.result.pages
				this.returnSupplierData.total = responseData.result.total
				this.returnSupplierData.pageNum = responseData.result.pageNum
				
				this.selectSupplierBox = true
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 获取业务商品
		async getBusinessGoods(){
			let responseData =  await this.$http.getBusinessGoods(this.getBusinessGoodsRequestData)
			if(responseData.status == 200){
				this.returnBusinessGoodsData.list = responseData.result.list
				this.returnBusinessGoodsData.pages = responseData.result.pages
				this.returnBusinessGoodsData.total = responseData.result.total
				this.returnBusinessGoodsData.pageNum = responseData.result.pageNum
				
				this.selectBusinessGoodsBox = true
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		setBisomessGppdsValueAction(row,column,event){
			this.selectBusinessGoodsBox =  false,
			sessionStorage.setItem('selectBusinessGoodsEntryInfo',JSON.stringify(row))
			// this.$emit('selectDataAction',row,this.fieldName,row[this.fieldValue]);
			this.$parent.isShowData(this.fieldName,row[this.fieldValue])
		},
		
		// 数据搜索
		searchBusinessGoodsData() {
			this.getBusinessGoodsRequestData.page = 1
			this.getBusinessGoods()
		},
		// 数据翻页
		setBusinessGoodsPageNumber(val){
			this.getBusinessGoodsRequestData.page = val
			this.getBusinessGoods()
		},
		
		// 切换显示条数
		setBusinessGoodsPageSize(val){
			this.getBusinessGoodsRequestData.page = 1
			this.getBusinessGoodsRequestData.rows = val
			this.getBusinessGoods()
		},
		
		
		
		openSelectUserBox(){
			this.selectUserBox = true
			this.getUserDataList()
			this.getUserGroupList()
		},
	
		setUserValueAction(row){
			this.selectUserBox =  false,
			sessionStorage.setItem('selectUserData',JSON.stringify(row))
			this.$parent.isShowData(this.fieldName,row[this.fieldValue])
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getUserRequestData.page = val
			this.getUserDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getUserRequestData.page = 1
			this.getUserRequestData.rows = val
			this.getUserDataList()
		},
		// 数据搜索
		searchData() {
			this.getUserRequestData.page = 1
			this.getUserDataList()
		},
		
		// 获取用户数据列表
		async getUserDataList(){
			let responseData =  await this.$http.getUserList(this.getUserRequestData)
			if(responseData.status == 200){
				this.returnUserData.list = responseData.result.list
				this.returnUserData.pages = responseData.result.pages
				this.returnUserData.total = responseData.result.total
				this.returnUserData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 获取用户分组数据
		async getUserGroupList(){
			let responseData =  await this.$http.getAllUserGroup(this.groupSearch)
			if(responseData.status == 200){
				this.userGroupList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.el-dialog__body{
	padding: 0;
}
</style>